<template>
  <transition name="fade">
    <div id="app" v-show="initialized">
      <main class="flex">
        <SideNavigation :agency="true" :user="user" />
        <div style="padding-left: 285px;"></div>
        <div style="width: 100%; background-color: #f7f7f7;">
          <div
            style="min-height: 101vh; width: 90%; max-width: 1500px; margin: 0 auto; padding-top: 34px;"
          >
            <router-view v-show="!loading" />
          </div>
        </div>
      </main>
    </div>
  </transition>
</template>

<script>
import SideNavigation from '@/components/DesignSystem/SideNavigation';
import AgencyStore from '@/store/agencyDashboard/index';
import { agencyDashboard } from '@/router/agencyDashboard/index';
import { mapGetters, mapActions } from 'vuex';
import '@/scss/directory.scss';
import '@/scss/web.scss';

export default {
  components: {
    SideNavigation,
  },
  data() {
    return {
      initialized: false,
    };
  },
  async created() {
    this.$store.registerModule('', AgencyStore);
    this.$router.addRoutes(agencyDashboard);
    await this.fetchAgencyProfileInformation();
    this.fetchSettings();
    this.fetchCategories();
    setTimeout(() => {
      this.$emit('initialized');
      this.initialized = true;
    }, 500);
  },
  computed: {
    ...mapGetters(['userMessage', 'loading', 'user']),
  },
  methods: {
    ...mapActions([
      'fetchAgencyProfileInformation',
      'fetchCategories',
      'fetchSettings',
    ]),
  },
};
</script>
